// GENERATED by scripts/gen-web-routes.mjs — regenerate after frontend/app/ changes.
import { createFileRoute } from "@tanstack/react-router"
import Page from "@/app/agents/memory-approvals/page"
import { usePageHead } from "../../../compat/head"

export const Route = createFileRoute("/agents/memory-approvals/")({
  component: PageComponent,

})

function PageComponent() {
  usePageHead({ title: "Duyệt trí nhớ agent" })
  return <Page />
}
